const IconAlertTriangleYellow = ({
  width,
  height,
}: {
  width: string
  height: string
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M27.6993 8.13579C26.0552 5.28807 21.9448 5.28807 20.3007 8.13579L4.57866 35.3672C2.93452 38.2149 4.98969 41.7745 8.27796 41.7745H39.722C43.0103 41.7745 45.0655 38.2149 43.4213 35.3672L27.6993 8.13579Z'
        fill='#FDD835'
      />
      <path
        d='M25.5005 34.5C25.5005 35.3284 24.8289 36 24.0005 36C23.1721 36 22.5005 35.3284 22.5005 34.5C22.5005 33.6716 23.1721 33 24.0005 33C24.8289 33 25.5005 33.6716 25.5005 34.5Z'
        fill='#343E47'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M24.0005 17C24.8289 17 25.5005 17.6716 25.5005 18.5V28.5C25.5005 29.3284 24.8289 30 24.0005 30C23.1721 30 22.5005 29.3284 22.5005 28.5V18.5C22.5005 17.6716 23.1721 17 24.0005 17Z'
        fill='#343E47'
      />
    </svg>
  )
}

export default IconAlertTriangleYellow
